import { ActionCardModel, FormulaQuestionNode } from './actionCard'

/**
 * Recalculates all Formula nodes within an Action Card.
 *
 * This utility function identifies nodes containing mathematical expressions,
 * executes their logic, and updates their state with the calculated numeric
 * result or a specific error code.
 *
 * !!! Important !!! This function mutates the state parameter
 */
export const recalculateFormulaNodes = (model: ActionCardModel) => {
  model
    .getSearchService()
    .toArray()
    .filter(node => node instanceof FormulaQuestionNode)
    .forEach(node => {
      const result = node.calculate()

      if (result.errorCode) {
        node.data.value = undefined
        node.data.error = result.errorCode
      } else {
        node.data.value = result.value
        node.data.error = undefined
      }
    })
}
